<template>
  <a-form
    layout="horizontal"
    v-on:submit="submitForm"
  >
    <div class="buttons">
        <a-button
            html-type="submit"
            type="primary"
        >
            Keresés
        </a-button>
        <a-button
            type="default"
            v-on:click="clearFilters"
        >
            Paraméterek törlése
        </a-button>
    </div>
    <SearchInput
        v-model="uniqueId"
        icon="barcode"
        label="Egyedi azonosító"
    />
    <a-divider>
    </a-divider>
    <SearchInput
        v-model="name"
        icon="solution"
        label="Info neve"
    />
    <a-divider>
    </a-divider>
    <SearchInput
        v-model="description"
        icon="file-text"
        label="Info leírása"
    />
    <a-divider>
    </a-divider>
    <SearchCheckboxes 
        :options="infoTypesOptions"
        :checkAllBox="true"
        label="Típus"
        v-model="isEmphasized"
    />
    <a-divider>
    </a-divider>
    <SearchDateRange
        v-model="modifiedAt"
        label="Módosítás dátuma"
    />
    <a-divider>
    </a-divider>
    <TagsSearchSelectWrapper 
        tagType="person"
        label="Kiről szól?"
        v-model="persons"
    />
    <a-divider>
    </a-divider>
    <TagsSearchSelectWrapper 
        tagType="topic"
        label="Témakör"
        v-model="topics"
    />
    <a-divider>
    </a-divider>
    <TagsSearchSelectWrapper 
        tagType="other"
        label="Egyéb címkék"
        v-model="tags"
    />
    <a-divider>
    </a-divider>
    <SearchSlider 
        :interval="true"
        v-model="priority"
        :max="5"
        :min="1"
        label="Prioritás"
    />
  </a-form>
</template>

<script>
import SearchCheckboxes from '@/components/app/search_components/SearchCheckboxes.vue';
import SearchDateRange from '@/components/app/search_components/SearchDateRange.vue';
import SearchSelect from '@/components/app/search_components/SearchSelect.vue';
import SearchSlider from '@/components/app/search_components/SearchSlider.vue';
import SearchInput from '@/components/app/search_components/SearchInput.vue';
import TagsSearchSelectWrapper from '@/components/app/search_components/TagsSearchSelectWrapper.vue';



export default {

    components: {
        SearchCheckboxes,
        SearchDateRange,
        SearchSelect,
        SearchSlider,
        SearchInput,
        TagsSearchSelectWrapper
    },

    props: {
        infoTypesOptions: {
            type: Array,
            default: () => []
        },
        formValues: {
            type: Object,
            default() {return {}}
        },
        defaultValues: {
            type: Object,
            default() {return {}}
        }
    },

    model: {
        prop: 'formValues',
        event: 'formChanged'
    },

    data() {
        return {
            formItemLayout: {
                labelCol: { span: 24 },
                wrapperCol: { span: 24 }
            },
            ...this.formValues
        }
    },
    created() {
        this.submitForm();  
    },

    methods: {
        submitForm($event) {
            if ($event) {
                $event.preventDefault();
            }
            const formData = {}

            Object.keys(this.defaultValues).forEach(key => {
                if (key === 'persons' || key === 'topics' || key === 'tags') {
                    formData[key] = this[key].map(el => el.id)
                } else {
                    formData[key] = this[key]
                }
                
            })
            console.log('SEARCHQUERY:  ', formData);
            this.$emit('sendQuery', formData);
        },
        clearFilters($event) {
            $event.preventDefault();
            Object.assign(this, {...this.defaultValues});
            this.submitForm($event);
        }
    }
}
</script>

<style lang="scss" scoped>
    .buttons {
        position: sticky;
        top: 0px;
        z-index: 2;
        display: flex;
        justify-content: space-evenly;
    }

</style>